import requestv2 from "~/utils/http-v2";

const builderLicenseApi = {
    get: async (params) => {
        const url = 'v2/builder-license';
        return await requestv2.get(url, {params});
    },
    detail: async (id) => {
        const url = `v2/builder-license/detail/${id}`;
        return await requestv2.get(url);
    },
    add: async (params) => {
        const url = 'v2/builder-license';
        return await requestv2.post(url, params);
    },
    update: async (id, params) => {
        const url = `v2/builder-license/${id}`;
        return await requestv2.patch(url, params);
    },
    delete: async (id) => {
        const url = `v2/builder-license/${id}`;
        return await requestv2.delete(url);
    },
    status: async (id, params) => {
        const url = `v2/builder-license/status/${id}`;
        return await requestv2.post(url, params);
    },
    generate: async (id, params) => {
        const url = `v2/builder-license/generate/${id}`;
        return await requestv2.post(url, params);
    },
};

export default builderLicenseApi;

